export const SET_FIRST_TIME_USER = "SET_FIRST_TIME_USER";
export const SET_LIVE_STATE = "SET_LIVE_STATE";

// Onboard actions
export const ONBOARD_OPENAPI_INPROGRESS = "ONBOARD_OPENAPI_INPROGRESS";
export const ONBOARD_OPENAPI_SUCCESS = "ONBOARD_OPENAPI_SUCCESS";
export const ONBOARD_OPENAPI_FAILED = "ONBOARD_OPENAPI_FAILED";

// get API Profile
export const OPENAPI_PROFILE_INPROGRESS = "OPENAPI_PROFILE_INPROGRESS";
export const OPENAPI_PROFILE_SUCCESS = "OPENAPI_PROFILE_SUCCESS";
export const OPENAPI_PROFILE_FAILED = "OPENAPI_PROFILE_FAILED";

// get client details actions
export const GET_CLIENT_DETAILS_INPROGRESS = "GET_CLIENT_DETAILS_INPROGRESS";
export const GET_CLIENT_DETAILS_FAILURE = "GET_CLIENT_DETAILS_FAILURE";
export const GET_CLIENT_DETAILS_SUCCESS = "GET_CLIENT_DETAILS_SUCCESS";

// Go live actions
export const GO_LIVE_REQUEST_INPROGRESS = "GO_LIVE_REQUEST_INPROGRESS";
export const GO_LIVE_REQUEST_FAILURE = "GO_LIVE_REQUEST_FAILURE";
export const GO_LIVE_REQUEST_SUCCESS = "GO_LIVE_REQUEST_SUCCESS";

// Update Live actions
export const UPDATE_LIVE_INPROGRESS = "UPDATE_LIVE_INPROGRESS";
export const UPDATE_LIVE_SUCCESS = "UPDATE_LIVE_SUCCESS";
export const UPDATE_LIVE_FAILURE = "UPDATE_LIVE_INPROGRESS";

// ACCOUNT_STATUS ACTIONS
export const UPDATE_CLIENT_DATA_SUCCESS = "UPDATE_CLIENT_DATA_SUCCESS";
export const UPDATE_CLIENT_DATA_FAILURE = "UPDATE_CLIENT_DATA_FAILURE";
export const UPDATE_CLIENT_DATA_INPROGESS = "UPDATE_CLIENT_DATA_INPROGESS";

// SUBACCOUNT CREATED ACTIONS
export const GET_SUBACCOUNTS_CREATED_INPROGRESS = "GET_SUBACCOUNTS_CREATED_INPROGRESS";
export const GET_SUBACCOUNTS_CREATED_FAILURE = "GET_SUBACCOUNTS_CREATED_FAILURE";
export const GET_SUBACCOUNTS_CREATED_SUCCESS = "GET_SUBACCOUNTS_CREATED_SUCCESS";

// GET_SUBACCOUNTS ACTIONS
export const GET_SUBACCOUNTS_INPROGRESS = "GET_SUBACCOUNTS_INPROGRESS";
export const GET_SUBACCOUNTS_FAILURE = "GET_SUBACCOUNTS_FAILURE";
export const GET_SUBACCOUNTS_SUCCESS = "GET_SUBACCOUNTS_SUCCESS";

// GET_SEARCH_SUBACCOUNT ACTIONS
export const GET_SEARCH_SUBACCOUNTS_INPROGRESS = "GET_SEARCH_SUBACCOUNTS_INPROGRESS";
export const GET_SEARCH_SUBACCOUNTS_FAILURE = "GET_SEARCH_SUBACCOUNTS_FAILURE";
export const GET_SEARCH_SUBACCOUNTS_SUCCESS = "GET_SEARCH_SUBACCOUNTS_FAILURE_SUCCESS";

// Test console actions
export const PUBLISH_TO_TEST_CONSOLE_INPROGRESS = "PUBLISH_TO_TEST_CONSOLE_INPROGRESS";
export const PUBLISH_TO_TEST_CONSOLE_FAILURE = "PUBLISH_TO_TEST_CONSOLE_FAILURE";
export const PUBLISH_TO_TEST_CONSOLE_SUCCESS = "PUBLISH_TO_TEST_CONSOLE_SUCCESS";
export const RESET_TEST_CONSOLE = "RESET_TEST_CONSOLE";

// GET_SUBACCOUNT_TRANSACTIONS ACTIONS
export const GET_SUBACCOUNT_TRANSACTIONS_INPROGRESS = "GET_SUBACCOUNT_TRANSACTIONS_INPROGRESS";
export const GET_SUBACCOUNT_TRANSACTIONS_FAILURE = "GET_SUBACCOUNT_TRANSACTIONS_FAILURE";
export const GET_SUBACCOUNT_TRANSACTIONS_SUCCESS = "GET_SUBACCOUNT_TRANSACTIONS_SUCCESS";

// GET_FILTERED_SUBACCOUNT_TRANSACTIONS ACTIONS
export const GET_FILTERED_SUBACCOUNT_TRANSACTIONS_INPROGRESS =
    "GET_FILTERED_SUBACCOUNT_TRANSACTIONS_INPROGRESS";
export const GET_FILTERED_SUBACCOUNT_TRANSACTIONS_FAILURE =
    "GET_FILTERED_SUBACCOUNT_TRANSACTIONS_FAILURE";
export const GET_FILTERED_SUBACCOUNT_TRANSACTIONS_SUCCESS =
    "GET_FILTERED_SUBACCOUNT_TRANSACTIONS_SUCCESS";

// Get Token Expiry
export const GET_TOKEN_EXPIRY_INPROGRESS = "GET_TOKEN_EXPIRY_INPROGRESS";
export const GET_TOKEN_EXPIRY_FAILURE = "GET_TOKEN_EXPIRY_FAILURE";
export const GET_TOKEN_EXPIRY_SUCCESS = "GET_TOKEN_EXPIRY_SUCCESS";

// Get Virtual account limit

export const GET_VIRTUAL_ACCOUNT_LIMIT_INPROGRESS = "GET_VIRTUAL_ACCOUNT_LIMIT_INPROGRESS";
export const GET_VIRTUAL_ACCOUNT_LIMIT_FAILURE = "GET_VIRTUAL_ACCOUNT_LIMIT_FAILURE";
export const GET_VIRTUAL_ACCOUNT_LIMIT_SUCCESS = "GET_VIRTUAL_ACCOUNT_LIMIT_SUCCESS";
